export const paginateRequest = (store, action, dispatchPaginationAction, dispatchFinishAction) => {
  const {pagination, results} = action.payload;
  const {totalResults, offset} = pagination;
  const newOffset = offset + results.length;
  if (newOffset < totalResults) {
    store.dispatch(dispatchPaginationAction(newOffset));
  } else if (dispatchFinishAction) {
    store.dispatch(dispatchFinishAction());
  }
};
